import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../../lib/requireAuth.jsx';
import withRouterParams from '../../../../lib/withRouterParams.jsx';

import StepStakeholderFormContainer from '../../../../containers/projects/StakeholderFormContainers/StepStakeholderFormContainer.jsx';

const NewProfileStepStakeholder = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>New Stakeholder | ChangeSync</title>
    </Helmet>
    <StepStakeholderFormContainer projectId={projectId} slug={slug} />
  </>
);

NewProfileStepStakeholder.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewProfileStepStakeholder));
